module.exports = __webpack_public_path__ + "images/emoji/egg.d8427c56d36f076fa666.png";